import { storeSupplierProfileMapping } from '@services/storeSupplierProfileMapping';

const getSupplierProfileBySupplierIdAndStoreId = (supplierId, storeId) =>
  storeSupplierProfileMapping.getSupplierProfileBySupplierIdAndStoreId(supplierId, storeId);

export default getSupplierProfileBySupplierIdAndStoreId;
